import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { ExamStudentAttempt, courseExamsApi } from "./courseExamsApi";
import { ExamStatusIds } from "consts";

export const useCourseStudentsExams = (courseId: number, courseExamId: number) => {
  const queryClient = useQueryClient();

  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_EXAM_BY_ID(Number(courseId), Number(courseExamId)),
    queryFn: async () => {
      const { data } = await courseExamsApi.fetchByIdWithStudents(Number(courseId), Number(courseExamId));
      const mapped = data.students.map((x): CourseStudentExamData => {
        const lastAttemptStatus = x.attempts.sort((a, b) => b.createdDate.valueOf() - a.createdDate.valueOf())[0]
          ?.status;

        return {
          id: x.user.id,
          userId: x.user.id,
          email: x.user.email,
          name: `${x.user.firstName} ${x.user.surname}`,
          lastAttempt: lastAttemptStatus,
          attempts: x.attempts,
        };
      });
      return { exams: mapped, name: data.name };
    },
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_EXAM_BY_ID(Number(courseId), Number(courseExamId)),
    });
  };

  return { invalidate, isLoading, exams: data?.exams || [], name: data?.name };
};

export interface CourseStudentExamData {
  id: number;
  userId: number;
  email: string;
  name: string;
  lastAttempt?: ExamStatusIds;
  attempts: ExamStudentAttempt[];
}
